// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17owi","index":"styles_index__2dSwF"};